import { Clock, MapPin, Phone } from 'lucide-react';
import { SectionLabel } from '@/components/marketing/v2/SectionLabel';

export default function ContactOfficeV2() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <div className="grid gap-12 md:grid-cols-[0.95fr_1.05fr] md:gap-16">
          {/* LEFT — Label + heading */}
          <div>
            <SectionLabel>Notre bureau</SectionLabel>
            <h2 className="mt-3 font-marketing-display text-[clamp(32px,4.4vw,56px)] font-bold leading-[1] tracking-[-0.035em] text-charcoal-800">
              Un bureau. <span className="underline-lime">Une équipe.</span>
              <br />
              Un produit.
            </h2>
            <p className="mt-5 max-w-md font-marketing-body text-[17px] leading-[1.55] text-charcoal-600">
              Velko est construit à Yaoundé par une équipe qui vit le terrain tous les jours. Pas de
              hub lointain, pas de support externalisé. Quand tu nous appelles, tu parles à
              quelqu'un qui connaît le produit.
            </p>
          </div>

          {/* RIGHT — Single HQ card */}
          <div className="relative border-[3px] border-charcoal-800 bg-charcoal-800 p-9 text-white shadow-neobrutal-10 md:p-10">
            <span className="absolute -top-3.5 left-8 border-2 border-charcoal-800 bg-lime-500 px-3 py-1 font-marketing-mono text-[10px] font-semibold uppercase tracking-[0.1em] text-charcoal-800 shadow-neobrutal-3">
              QG
            </span>

            <h3 className="font-marketing-display text-[32px] font-bold tracking-[-0.02em]">
              Yaoundé
            </h3>
            <div className="mt-2 font-marketing-mono text-[11px] font-medium uppercase tracking-[0.12em] text-lime-400">
              Cameroun · Siège social
            </div>

            <div className="mt-6 font-marketing-body text-[15px] leading-[1.6] text-charcoal-200">
              Rond-Point Damas
              <br />
              Yaoundé, Cameroun
            </div>

            <div className="mt-7 flex flex-col gap-3 border-t border-charcoal-700 pt-5">
              <div className="flex items-center gap-3 font-marketing-mono text-[13px] text-charcoal-200">
                <Phone className="h-[14px] w-[14px] text-lime-400" strokeWidth={2.4} />
                <a href="tel:+237656488879" className="transition-colors hover:text-lime-400">
                  +237 656 48 88 79
                </a>
              </div>
              <div className="flex items-center gap-3 font-marketing-mono text-[13px] text-charcoal-200">
                <Clock className="h-[14px] w-[14px] text-lime-400" strokeWidth={2.4} />
                Lun-Ven · 8h-18h GMT+1
              </div>
              <div className="flex items-center gap-3 font-marketing-mono text-[13px] text-charcoal-200">
                <MapPin className="h-[14px] w-[14px] text-lime-400" strokeWidth={2.4} />
                Équipe entièrement basée au Cameroun
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
